import { useState } from 'react';
import { todayIsoParis } from '@lemontaigu/staff';
import { FrDateInput } from '@lemontaigu/reception/ui/FrDateInput.js';
import {
  CleaningBlocks,
  CleaningLegend,
  useCleaningRows,
} from '@lemontaigu/reception/team/CleaningList.js';
import { shiftDay } from './logic.js';

// « Ménage » on the phone — the printed sheet's own tab (operator, 2026-09-10:
// *"can it live in staff.* on its own tab? maybe 3 or 4 per rows; that could
// help better than papers"*).
//
// ── Same rows, same marks, deliberately ───────────────────────────────────
//
// Three per line instead of five, and no print button. Nothing else differs —
// the underline, the bold and the write-on slot mean exactly what they mean on
// paper, and the room counts are the same figures. That is the point: while
// both exist, someone reading the phone and someone reading the sheet must be
// looking at the same day. A phone variant that "simplified" a mark would
// create two vocabularies for one job.
//
// ── Its own tab, not a strip under Présence ───────────────────────────────
//
// Présence answers « who is working »; this answers « which rooms ». The étage
// opens it and stays in it for a morning, so it gets a day picker of its own
// rather than inheriting one from a screen about something else.
//
// ── What it is NOT, yet ───────────────────────────────────────────────────
//
// Read-only. The operator has raised a « punch » to mark a room done, which
// would make this the authoritative list and the paper a fallback. That is a
// bigger change than a view: it needs a write path, a room state that survives
// a reload, and an answer to what happens when two people tick the same room —
// and, in the operator's own words, *« I am just NOT sure myself how they
// actually work; and it changes if they are 1, 2, 3 or 4 of them »*. Until
// that is understood, a half-built tick produces exactly the failure they
// named: rooms nobody did, because each thought the other had.

export function Menage() {
  const [day, setDay] = useState(() => todayIsoParis());
  const { rows, err } = useCleaningRows(day);

  return (
    <div className="planning-board">
      <div className="staff-daybar">
        <button type="button" onClick={() => setDay(shiftDay(day, -1))} aria-label="Jour précédent">
          ‹
        </button>
        <FrDateInput className="pt-datepicker" value={day} onChange={(v) => v && setDay(v)} />
        <button type="button" onClick={() => setDay(shiftDay(day, 1))} aria-label="Jour suivant">
          ›
        </button>
        <button type="button" onClick={() => setDay(todayIsoParis())}>
          Aujourd’hui
        </button>
      </div>

      {err && <p className="auth-err">Erreur : {err}</p>}
      {!err && rows === null && <p className="staff-empty">Chargement…</p>}

      {rows && (
        <div className="cleaning-list is-phone">
          <CleaningBlocks rows={rows} perRow={3} />
          <CleaningLegend />
        </div>
      )}
    </div>
  );
}
